import { Text, XStack } from '@frontend/web-react';
import { mergeAndConcatClasses } from '@frontend/web-utils';
import type { ReactNode } from 'react';

type CalloutBadgeProps = {
  children: ReactNode;
  className?: string;
};

export const CalloutBadge = ({ children, className }: CalloutBadgeProps) => {
  return (
    <XStack
      alignItems="center"
      className={mergeAndConcatClasses('self-start rounded-sm bg-surfaceAccent', className)}
      px="sm"
      py="xs"
    >
      <Text className="text-textPrimary" type="captionBold">
        {children}
      </Text>
    </XStack>
  );
};
